import React from 'react'

// utils
import { createRequestsList } from './InventoryEquipmentRequests.utils'

// query
import { useQuery } from '@apollo/client'
import { GET_EQUIPMENT_REQUESTS_BY_STATUS } from '../../../../graphql/equipmentRequest/equipmentRequest.queries'

// components
import Card from '../../../../components/cards/Card/Card.component'
import CardListItem from '../../../../components/cards/CardListItem/CardListItem.component'

// icons
import { FontAwesomeIcon  } from '@fortawesome/react-fontawesome'
import { faScrewdriverWrench } from '@fortawesome/free-solid-svg-icons'


export default function InventoryEquipmentRequests({ status }) {

    let list = []

    const { loading, error, data } = useQuery(GET_EQUIPMENT_REQUESTS_BY_STATUS, {
        variables: { status }
    })

    if(data && data.equipmentRequestsByStatus) {
        list = createRequestsList(data.equipmentRequestsByStatus)
    }

    return (<Card header={{ icon: <FontAwesomeIcon icon={faScrewdriverWrench} size='2x' color='#707070' />, title: "Equipment Requests", linkPath: '/inventory/equipment-requests'}}>
        
        {
            list.map(request => {
                return <CardListItem title={request.job} subtitle={request.status} linkText="Details" linkPath={`/inventory/equipment-requests/${request.id}`} />
            })
        }

    </Card>)

}